import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';
import { ContactAgentFormatter } from './contact.agent.formatter';
import { AxiosPromise } from '../../utils/axios.promise';
import { CommonConfig } from '../../configs/config.common';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { ContactAgentValidator } from './contact.agent.validator';
import { ILeadCreateForm, createLead, getSourceChannel } from '../../utils/lead.manager';

@Component({
   components: {
      ASpaceInBetweenAnother
   }
})
export default class ContactAgent extends Vue {
   public title: string = 'ContactAgent';

   @Prop()
   public isShowUserRegister!: boolean;
   public config = new CommonConfig();

   public agentName: string = '';

   public phoneE164: string = '';

   public phone: string = '(416)883-9666';

   public bottomOffset = '0px;';

   public bottom = 0;

   public formatter = new ContactAgentFormatter();

   public modalVisible: boolean = false;

   public regionCode = '+1';

   get getShowUserRegister() {
      return this.isShowUserRegister;
   }
   public regionCodes: any[] = [
      { value: '+1', text: '+1' },
      // { value: '+86', text: '+86' },
   ];

   @Prop({ default: '' })
   public remarkProp: any;

   public fields: any = {
      name: {
         value: '',
         state: null,
      },
      remark: {
         value: this.remarkProp,
         state: null
      },
      phone: {
         value: '',
         state: null
      },
      email: {
         value: '',
         state: null
      }
   };

   public async handleClick() {
   }

   public checkFormValidity() {
   }

   public resetModal() {
      this.fields = {
         name: {
            value: '',
            state: null,
         },
         remark: {
            value: this.remarkProp,
            state: null
         },
         phone: {
            value: '',
            state: null
         },
         email: {
            value: '',
            state: null
         }
      };
   }

   public created() {
   }

   public async mounted() {
      this.setBottomOffset();
      this.$store.commit('updateBottomMargin', true);
   }

   public beforeDestory() {
      this.$store.commit('updateBottomMargin', false);
   }
   public async handleOk(evt: any) {
      evt.preventDefault();
      this.$store.commit('appStartFetching');
      // console.log(this.fields);
      await this.handleSubmit();
      this.$store.commit('appEndFetching');
      this.resetModal();
   }

   public async handleSubmit() {
      this.fields.phone.value = this.fields.phone.value.replace(/ /g, '');
      const validateResult = ContactAgentValidator.validator(this.fields);
      if (!T_T.simpleDetect(validateResult)) {
         const leadForm: ILeadCreateForm = {
            leadName: 'Lead From EpicWeb',
            clientName: this.fields.name.value,
            email: this.fields.email.value,
            phone: `${this.fields.phone.value}`,
            registerAccount: false,
            channel: getSourceChannel(this.$i18n.locale),
            agentRefer: this.$store.state.auth.userInfo.value.agentName,
            yonghuId: this.$store.state.auth.userInfo.value.yonghuId,
            clientMsg: this.fields.remark.value
         };
         const result = await createLead(leadForm);
         this.$Notice.success({
            title: 'Message Sent',
            desc: 'Thank you.'
         });
         this.modalVisible = false;
      } else {
         alert(validateResult);
      }
   }

   public getScreenWidth() {
      return screen.width;
   }

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public onUserChanged(val: any, oldVal: any) {
      this.agentName = val.value.agentName;
      this.phoneE164 = T_T.simpleDetect(val.value.agentMobile) ? val.value.agentMobile : val.value.agentPhone;

      try {
         if (this.phoneE164) {
            const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
            const phoneNumber: PhoneNumber = phoneUtil.parseAndKeepRawInput(this.phoneE164);
            this.phone = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
         }
      } catch (e) {
         console.error(`Invalid Phone Number---------------------${this.phoneE164}`);
      }
   }

   @Watch('$store.state.scrollBar.scrollY', { immediate: true, deep: true })
   public onScrollYChanged(val: any, oldVal: any) {
      this.setBottomOffset();
      // console.log(this.bottomOffset);
   }

   public setBottomOffset() {
      // const bottom = document.documentElement.offsetHeight - (this.$store.state.scrollBar.scrollY + window.innerHeight);
      // this.bottom = bottom;
      // const offset = this.bottom <= 0 ? 0 : bottom;
      // if (bottom <= 50) {
      //    this.bottomOffset = `-${50 - offset}px`;
      // } else {
      this.bottomOffset = '0px';
      // }
   }
}
